import styled from 'styled-components'

type ScanAndPayType = {
  isClickCollect?: boolean
}

export const PDFContainer_Outer = styled.div`
  min-height: calc(424px + 42px + 10px);
  width: 300px;
  margin: 0 auto;

  gap: 10px;

  display: flex;
  flex-direction: column;
  align-items: center;
`

// 396.84 = 720.54
// 300    = 544.71
// 424.72

export const PDFContainer = styled.div`
  height: 148mm;
  width: 105mm;
  padding: 0;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center center;
`

export const Background = styled.img`
  height: 100%;
  width: 100%;
  position: absolute;
  z-index: -1;
  aspect-ratio: 1 / 1;
`

export const Logo = styled.img`
  margin-top: 7mm;
  max-height: 50mm;
  max-width: 50mm;
`

export const CompanName = styled.p`
  height: 15mm;
  line-height: 15mm;
  font-size: 10mm;
  color: #fff;
  text-align: center;
  margin: 0;
  margin-bottom: 5mm;
`

export const QRCodeContainer = styled.div`
  width: 30mm;
  height: 30mm;
  background-color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0 auto;
`

export const TableName = styled.p`
  height: 14mm;
  line-height: 14mm;
  font-size: 7mm;
  color: #fff;
  text-align: center;
  margin: 0;
  margin-top: 2mm;
`

export const ScanAndPay = styled('p')<ScanAndPayType>`
  font-family: 'Roboto', sans-serif;
  height: 20mm;
  line-height: 20mm;
  font-size: ${({ isClickCollect }) => (isClickCollect ? '6mm' : '13mm')};
  color: #fff;
  text-align: center;
  margin: 0;
`

// SpecialLayout

export const FrameDiv = styled.div`
  border: ${({ color }) => `2px solid ${color}`};
  width: calc(100% - 20px);
  margin: 10px auto 0;

  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  * {
    font-family: 'Arial', sans-serif; // font is important due to pdf-export and must be web-safe
  }
`

export const LogoSpecialContainer = styled.div`
  margin: 7mm 0;
  height: 38mm;
  width: 38mm;

  display: flex;
  justify-content: center;
  align-items: center;
`

export const LogoSpecial = styled.img`
  max-height: 38mm;
  max-width: 38mm;
  object-fit: contain;
`

export const OrderPaySpecial = styled.div`
  height: 8.725mm;
  line-height: 8.725mm;
  font-size: 8.5mm;
  color: #fff;
  text-align: center;
  margin: -10px 0;
  text-align: center;
`

export const ScannerText = styled.div`
  color: #fff;
  font-size: 3mm;
  text-align: left;
  text-align: center;
  margin: 7mm 1.75mm;
`

export const TableNameSpecial = styled.div`
  position: absolute;

  top: 5px;
  right: 5px;

  display: flex;
  flex-direction: column;
  align-items: center;
  color: #fff;
  p {
    margin: 0;
    font-weight: 600;
  }
  p:first-child {
    font-size: 18px;
    margin: 5px 0;
  }
  p:last-child {
    font-size: 9px;
  }
`
